<div class="container">
  <!-- section title -->
  <h2 class="section-title wow fadeInUp">Experience</h2>

  <div class="spacer-60"></div>

  <div class="row">
    <div class="col-md-6">
      <!-- timeline wrapper -->
      <div class="timeline edu rounded bg-white shadow-dark padding-30 overflow-hidden">
        <!-- timeline item -->
        <div class="timeline-container wow fadeInUp">
          <div class="content">
            <span class="time">2019-2023</span>
            <h3 class="title">Bachelor's Degree</h3>
            <p>University of Zimbabwe </p>
            <p>Bsc Hon Computer Science </p>
            <p>Degree class - 1</p>
          </div>
        </div>

        <!-- timeline item -->
        <div class="timeline-container wow fadeInUp" data-wow-delay="0.2s">
          <div class="content">
            <span class="time">2013 - 2019</span>
            <h3 class="title">High School Diploma</h3>
            <p>Harare High School </p>
            <p>Ordinary and Advanced level</p>
          </div>
        </div>

        <!-- timeline item -->
        <div class="timeline-container wow fadeInUp" data-wow-delay="0.4s">
          <div class="content">
            <span class="time">2003-2013</span>
            <h3 class="title">Elementary School</h3>
            <p>Chirodzo School</p>
          </div>
        </div>

        <!-- main line -->
        <span class="line"></span>
      </div>
    </div>

    <div class="col-md-6">
      <!-- responsive spacer -->
      <div class="spacer-30 d-md-none d-lg-none"></div>

      <!-- timeline wrapper -->
      <div class="timeline exp bg-white shadow-dark rounded padding-30 overflow-hidden">
        <!-- timeline item -->
        <div class="timeline-container wow fadeInUp">
          <div class="content">
            <span class="time">2019 - Present</span>
            <h3 class="title">Web and Mobile Developer</h3>
            <p>Professional web and mobile development.</p>
          </div>
        </div>

        <!-- timeline item -->
        <div class="timeline-container wow fadeInUp" data-wow-delay="0.2s">
          <div class="content">
            <span class="time">2020 - present</span>
            <h3 class="title">UX Designer</h3>
            <p>Professional UX designing (Google certified - June 2024).</p>
          </div>
        </div>

        <!-- timeline item -->
        <div class="timeline-container wow fadeInUp" data-wow-delay="0.4s">
          <div class="content">
            <span class="time">2023 - present</span>
            <h3 class="title">Back-End Developer</h3>
            <p>Skill building in progress - slightly proffesional.</p>
          </div>
        </div>

        <!-- main line -->
        <span class="line"></span>
      </div>
    </div>
  </div>
</div>
